import React, {Component} from 'react'
import styles from './GalleryViewer.css'
import PropTypes from 'prop-types'
import SliderNavigation from '../SliderNavigation/SliderNavigation'
import GalleryViewerItem from '../GalleryViewerItem/GalleryViewerItem'
import MenuToggle from '../MenuToggle/MenuToggle'
import {defineSwipe, Swipeable} from 'react-touch'
import {TypeImage, TypeRoute} from '../../constants/consts-prop-types'
import {analyticsEvent} from "../../services/service-analytics"

class GalleryViewer extends Component {
  static propTypes = {
    currentRoute: TypeRoute,
    items: PropTypes.arrayOf(TypeImage).isRequired,
    numInview: PropTypes.number.isRequired,
    currentIndex: PropTypes.number,
    onCloseClick: PropTypes.func.isRequired
  }

  static defaultProps = {
    numInview: 1,
    currentIndex: 0
  }

  constructor(props) {
    super(props)

    this.state = {
      currentIndex: this.props.currentIndex,
      entered: false
    }

    this.itemWidthGap = 100 / 14 * 13 / this.props.numInview
    this.swipeConfig = defineSwipe({swipeDistance: 50})

    this.onSwipeLeft = this.onSwipeLeft.bind(this)
    this.onSwipeRight = this.onSwipeRight.bind(this)
    this.onSliderNavClick = this.onSliderNavClick.bind(this)
    this.moveToCurrentIndex = this.moveToCurrentIndex.bind(this)
    this.slideToCurrentIndex = this.slideToCurrentIndex.bind(this)
    this.renderGalleryViewerItem = this.renderGalleryViewerItem.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.moveToCurrentIndex)
    this.moveToCurrentIndex()

    setTimeout(() => {
      this.setState({
        entered: true
      })
    }, 0)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.moveToCurrentIndex)
  }

  onSliderNavClick(direction) {
    this.setState(prevState => {
      let nextIndex = prevState.currentIndex + direction

      if (nextIndex < 0) nextIndex = this.props.items.length - 1
      if (nextIndex > this.props.items.length - 1) nextIndex = 0

      return {
        currentIndex: nextIndex
      }
    }, () => {
      this.slideToCurrentIndex()
    })
  }

  moveToCurrentIndex() {
    const xPosRow = (this.state.currentIndex * this.itemWidthGap) * -1
    window.TweenLite.set(this.itemsContainer, {transform: `translateX(${xPosRow}vw)`})

    analyticsEvent('gallery', 'open')
  }

  slideToCurrentIndex() {
    const xPosRow = (this.state.currentIndex * this.itemWidthGap) * -1
    window.TweenLite.to(this.itemsContainer, .35, {transform: `translateX(${xPosRow}vw)`, ease: window.Power2.easeInOut})
  }

  onSwipeLeft() {
    if(this.isIIIFItem()) return
    this.onSliderNavClick(1)
  }

  onSwipeRight() {
    if(this.isIIIFItem()) return
    this.onSliderNavClick(-1)
  }

  isIIIFItem() {
    return Boolean(this.props.items[this.state.currentIndex].iiif_url)
  }

  renderGalleryViewerItem(data, idx) {
    return (
      <GalleryViewerItem
        key={idx}
        index={idx}
        data={data}
        numInview={this.props.numInview}
        inView={this.state.currentIndex === idx}
      />
    )
  }

  render() {
    const {
      currentRoute,
      items,
      numInview,
      onCloseClick
    } = this.props

    const {
      currentIndex,
      entered
    } = this.state

    const hasItems = Boolean(items && items.length > 0)
    const numItems = hasItems ? items.length : 0

    const styleItemsContainer = {
      width: `${numItems * (100 / 14 * 13) / numInview}vw`
    }

    return (
      <div className={entered ? styles.GalleryViewerOpen : styles.GalleryViewer}>

        <div className={`container-fluid ${styles.navContainer}`}>
          <div className={styles.navRow}>

            <div className={styles.galleryNav}>
              {numItems > 1 &&
              <SliderNavigation
                currentRoute={currentRoute}
                onSliderNavClick={this.onSliderNavClick}
                numItems={numItems}
                currentIndex={currentIndex}
              />
              }
            </div>

            {numItems > 1 &&
            <div className={styles.counter}>
              <span>{`${currentIndex + 1} / ${numItems}`}</span>
            </div>
            }

            <div className={styles.buttonCloseContainer}>
              <MenuToggle
                isOpen={true}
                onMenuToggle={onCloseClick}
              />
            </div>

          </div>
        </div>

        {hasItems &&
        <div className={`container-fluid ${styles.sliderContainer}`}>
          <Swipeable config={this.swipeConfig} onSwipeLeft={this.onSwipeLeft} onSwipeRight={this.onSwipeRight}>
            <div
              ref={node => this.itemsContainer = node}
              className={styles.itemsContainer}
              style={styleItemsContainer}
            >
              {items.map((item, idx) => this.renderGalleryViewerItem(item, idx))}
            </div>
          </Swipeable>
        </div>
        }

      </div>
    )
  }
}

export default GalleryViewer



// WEBPACK FOOTER //
// ./src/components/GalleryViewer/GalleryViewer.js